export const CHANNEL_LIST = Object.freeze({
  CHAT_ROOM_CHANNEL: 'ChatRoomChannel',
})
